import React from 'react';
import {Video, Formatted} from 'components';
import {config} from 'helpers';

export function StrengthsGoDeeper() {
  return (
    <Formatted className="medium-spacing">
      <Video.Video src={config.videos.identity.strengths2} />
      <div className="medium-spacing">
        <p>Pick one of your strengths that you are proud of and consciously let it shine for a week. Exaggerate it, even. Notice how it feels to do something that is so effortless, yet so real. Try to bring it into as many aspects of your life as possible. Notice the impact this strength has on those around you. How do you feel?</p>
        <p>During the same week, notice the strengths of those around you and tell them what you see. Acknowledging the good in someone else will make more room to see the good in yourself.</p>
      </div>
    </Formatted>
  );
}
